// /settings/password — «Пароль» (001, FR-009а): текущий и новый пароль, «Сохранить изменения».
// Право — profile.change_password; без него — «Нет доступа».
import { createFileRoute } from '@tanstack/react-router';
import { PasswordPage } from '../../../features/profile/PasswordPage.tsx';

export const Route = createFileRoute('/_app/_settings/settings/password')({
  staticData: { crumb: 'Пароль' },
  component: PasswordPage,
});
